<template>
  <div>
    <Dialog :initialFocus="resetPasswordButtonRef" as="div" class="relative z-100">
      <TransitionChild as="template" enter="duration-300 ease-out" enter-from="opacity-0" enter-to="opacity-100"
        leave="duration-200 ease-in" leave-from="opacity-100" leave-to="opacity-0">
        <div class="fixed inset-0 bg-black/90" />
      </TransitionChild>

      <div class="fixed inset-0 overflow-y-auto">
        <div class="flex min-h-full items-center justify-center p-4 text-center">
          <TransitionChild as="template" enter="duration-300 ease-out absolute "
            enter-from="opacity-0 scale-95 bottom-full" enter-to="opacity-100 scale-100 bottom-[35%]"
            leave="duration-200 ease-in absolute" leave-from="opacity-100 scale-100 bottom-[35%]"
            leave-to="opacity-0 scale-95 bottom-full">
            <DialogPanel
              class="flex flex-col w-[407px] max-w-md transform rounded-2xl bg-white p-6 text-start align-middle shadow-xl transition-all  h-[365px] max-h-[75vh]">
              <a role="button" @click="cancel()" class="absolute md:-top-0 -top-10 md:-right-[8%] right-0 ">
                <img src="../../assets/images/icons/ic-close-light.svg" width="21" height="21" />
              </a>
              <DialogTitle as="h3" class=" leading-6 ">
                <h5 class="text-dark-4 font-bold text-2xl">{{  forgetPasswordModalTitle ? forgetPasswordModalTitle : t('modal.forgot_pass_title') }}</h5>
                <p class="text-dark-2 mt-8 font-regular">
                  {{ t('modal.forgot_pass_subtitle') }}
                </p>
              </DialogTitle>
              <!-- Dialog Content  -->
              <div class="mt-8">
                <section class="text-sm text-gray-500">
                  <form name="modalForm" @submit.prevent="goToResetPassword()">
                    <!-- Email  input -->
                    <div class=" ">
                      <label for="email" class="text-sm  text-secondary">
                        {{ t('inputs.Your_Email') }}
                        <span v-if="v$.email.$error" class="text-red">*</span>
                      </label>
                      <input type="text" name="email" autocomplete="nope"
                        class="form-control transition ease-in-out focus:ring-[#F6F6F6] focus:bg-white focus:gray-300 placeholder-dark-2/20 focus:border-[#F6F6F6]"
                        :placeholder="t('inputs.email_place_holder')" v-model.trim="v$.email.$model" />
                      <p v-if="v$.email.$error" class="input-err m-0 mt-1 block text-xs text-red font-regular"
                        v-for="error of v$.email.$errors" :key="error.$uid">
                        {{ error.$message }}
                      </p>
                    </div>

                    <div class="mt-8 flex flex-col justify-end">
                      <primary-button type="submit" class="m-auto w-full cursor-pointer">
                        {{ t('modal.Reset_Password') }}
                      </primary-button>

                    </div>
                  </form>
                </section>
              </div>
            </DialogPanel>
          </TransitionChild>

        </div>
      </div>
    </Dialog>

    <!-- loader -->
    <Loader :modalIsOpen="isLoading" :initFocusedRef="resetPasswordButtonRef" class="" :widthSM="true"></Loader>
  </div>

</template>
<script>
import { ref, reactive, computed } from "vue";
import { useI18n } from "vue-i18n";
import Request from "@/common/Request"
import Response from "@/common/Response"

import PrimaryButton from "@/components/atoms/buttons/PrimaryButton";
import Loader from "@/components/atoms/Loader";

//form validations
import useValidate from '@vuelidate/core'
import { required, email, helpers, } from '@vuelidate/validators'

import {
  Dialog,
  DialogPanel,
  DialogTitle,
  TransitionChild,
  //   TransitionRoot
} from '@headlessui/vue';

export default {
  name: "forgot-password-modal",

  components: {
    Loader,
    PrimaryButton,
    Dialog,
    DialogTitle,
    DialogPanel,
    TransitionChild,
  },
  emits: ["openSendEmailModal", "cancel"],
  props:['forgetPasswordModalTitle'],
  setup(props, { emit }) {
    const { t } = useI18n();
    const isLoading = ref(false)

    const resetPasswordButtonRef = ref()

    const resetPassForm = reactive({
      email: '',
    })
    const rules = computed(() => {
      return {
        email: {
          required: helpers.withMessage(t('messages.email_is_required'), required),
          email: helpers.withMessage(t('messages.email_is_Invalid'), email)
        },

      }
    })
    const v$ = useValidate(rules, resetPassForm)

    const goToResetPassword = async function () {
      const isValid = await this.v$.$validate()
      const isDirty = await this.v$.$dirty

      if (isValid && isDirty) {
        isLoading.value = true
        // isLoading.value = true
        let payload = {
          email: resetPassForm.email,
        }
        
        //  send email to reset password
        new Request().post("password/forget", payload).then((res) => {
          if (res?.data) {

            setTimeout(() => {
              isLoading.value = false
            })

            //show sent email modal
            setTimeout(() => {
                emit('cancel')
                emit('openSendEmailModal')

            }, 350)


          } else {
            isLoading.value = false
          }

        }, (err) => {
          new Response({ message: t('messages.Internal_Error') }).displayErrors()
          isLoading.value = false
        })
      }

    }
    return {
      t,
      isLoading,
      resetPasswordButtonRef,
      cancel() {
        emit('cancel')
      },
      resetPassForm, v$,
      goToResetPassword,
    }
  }
}
</script>
<style scoped lang="scss">
input {
  @apply block w-full px-4 mt-1 text-sm font-normal text-gray-700 bg-clip-padding border border-solid rounded m-0 focus:outline-none border-[#F6F6F6] bg-[#F6F6F6] focus:text-secondary;
}
</style>